const associar_disciplinas_para_uma_estrutura_curricular_supletivo = [
  {
    path: "/associar_disciplinas_para_uma_estrutura_curricular_supletivo",
    redirect: "",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      breadCrumb: "Informações Acadêmicas - Manutenção de Histórico",
      allowedPermissions: ["comp_sem_fase_show", "comp_sem_fase_list"],
    },
    children: [
      {
        path: "/associar-disciplinas-para-uma-estrutura-curricular-supletivo",
        name: "associar_disciplinas_para_uma_estrutura_curricular_supletivo",
        component: () =>
          import(
            "@/views/AssociarDisciplinaParaEstruturaCurricular/AssociarDisciplinaParaEstruturaCurricularHome.vue"
          ),
        meta: {
          allowedPermissions: ["comp_sem_fase_list"],
        },
      },
      {
        path: "/cadastrar-associar-disciplinas-para-uma-estrutura-curricular-supletivo",
        name: "cadastrar_associar_disciplinas_para_uma_estrutura_curricular_supletivo",
        component: () =>
          import(
            "@/views/AssociarDisciplinaParaEstruturaCurricular/AssociarDisciplinaParaEstruturaCurricularCad.vue"
          ),
        meta: {
          allowedPermissions: ["comp_sem_fase_create"],
        },
      },
      {
        path: "editar-associar-disciplinas-para-uma-estrutura-curricular-supletivo/:id",
        name: "editar_associar_disciplinas_para_uma_estrutura_curricular_supletivo",
        component: () =>
          import(
            "@/views/AssociarDisciplinaParaEstruturaCurricular/AssociarDisciplinaParaEstruturaCurricularEdit.vue"
          ),
        props: (route) => ({ isEdit: route.query.isEdit }),
        meta: {
          allowedPermissions: ["comp_sem_fase_edit"],
        },
      },
    ],
  },
];

export { associar_disciplinas_para_uma_estrutura_curricular_supletivo };
